import {
  biaInterfaceTypeOptions,
  biaIpTypeOptions,
  diaAccessTechOptions,
} from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const biaResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "downloadSpeed",
    required: true,
    patternMessage: "Download speed must be between 0.128 and 10,000 Mbps",
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    type: "select",
    attribute: "interface",
    required: true,
    options: biaInterfaceTypeOptions,
  },
  {
    type: "text",
    attribute: "uploadSpeed",
    required: true,
    patternMessage: "Upload speed must be between 0.128 and 10,000 Mbps",
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    attribute: "SlaUptime",
    type: "text",
    required: true,
    pattern: /^(100(\.0{1,3})?|[0-9]?[0-9](\.\d{1,3})?)$/,
    patternMessage: "SLA Uptime must be a number between 0 and 100",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "AccessTechnology",
    type: "select",
    options: diaAccessTechOptions,
    required: false,
    selectClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "SlaMTTR",
    type: "text",
    required: true,
    pattern: /^([1-9]\d{0,2}|1000)(\.\d{1,2})?$/,
    patternMessage: "SLA MTTR must be between 1 and 1000 hours",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "lastMileProvider",
    type: "text",
    required: true,
    pattern: /^[a-zA-Z0-9\s\-.,]{2,100}$/,
    patternMessage: "Last Mile Provider must be 2–100 characters, no special characters",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "isLocalTax",
    type: "select",
    required: false,
    options: includedOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "contractTerm",
    type: "select",
    options: [...contractTermsOptions],
    required: true,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "localTax",
    type: "text",
    required: true,
    pattern: /^(100(\.0+)?|[0-9]?\d(\.\d+)?|0)$/,
    patternMessage: "Local Tax must be a number between 0 and 100",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "IP",
    type: "select",
    options: biaIpTypeOptions,
    required: false,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];
export default biaResStrategy;
